import React from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import { Text as TextComponent } from '@chakra-ui/react';
import { Button } from '@landsvirkjun/react.common';

type RejectionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isDeletingApprover: boolean;
  onDeleteApprover: () => void;
  approverName: string;
};

export const DeleteApproverModal = ({
  isOpen,
  onClose,
  isDeletingApprover,
  onDeleteApprover,
  approverName,
}: RejectionModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Eyða samþykkjenda</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <TextComponent>
            Ertu viss um að þú viljir eyða <strong>{approverName}</strong> af
            lista samþykkjenda?
          </TextComponent>
        </ModalBody>

        <ModalFooter>
          <Button variant="warning" mr={3} onClick={onClose}>
            Hætta við
          </Button>
          <Button
            variant="primary"
            onClick={onDeleteApprover}
            isLoading={isDeletingApprover}
            loadingText="Augnablik..."
          >
            Eyða samþykkjenda
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
